import React, { useEffect, useState } from "react";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import Footer from "../../Component/Footer";
import { spin } from "../../Common/NewLoader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import ProjectManagementServices from "../ProjectManagementServices";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from "@mui/material";
import Swal from "sweetalert2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import deleteIcon from "../../images/Icons/delete.png";

const ProjectDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getProjectDetails();
  }, []);

  const getProjectDetails = () => {
    setLoading(true);
    ProjectManagementServices.GetProjectById(params.id)
      .then((response) => {
        setData(response.data);
        console.log("response.data", data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }


  const handleDeleteSite = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        ProjectManagementServices.DeleteSite(id).then(() =>

          getProjectDetails()
        );
      }
    });
  };

  const handleApproveChange = (Status) => {
    // console.log("asaasa", (data.projectmanager.length > 0), (data.clientassign.length > 0), (data.site.length > 0));

    if ((data.projectmanager.length > 0) &&
      (data.clientassign.length > 0) &&
      (data.site.length > 0)) {
      Swal.fire({
        title: `Are you sure you want to Approve This Project?`,
        text: ".",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let approvedata = {
            projectId: data.projectId,
            approveStatus: Status,
            status: "Active",
            updatedby: data.updatedby,
            tenantId: data.tenantId,
          }
          ProjectManagementServices.UpdateProjectApproval(approvedata).then(() =>
            getProjectDetails()
          )
        }
      });
    }
    else {
      if ((data.projectmanager.length === 0)) {
        Swal.fire({
          title: `Add Project Manager`,
          text: "",
          icon: "question",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }
      if ((data.clientassign.length === 0)) {
        Swal.fire({
          title: `Add Client`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }
      if ((data.site.length === 0)) {
        Swal.fire({
          title: `Add Site`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

    }

  };

  const handleReviseChange = (Status) => {
    Swal.fire({
      title: `Are you sure you want to Revise This Project?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        let approvedata = {
          projectId: data.projectId,
          approveStatus: Status,
          updatedby: data.updatedby,
          tenantId: data.tenantId,
        }
        ProjectManagementServices.UpdateProjectApproval(approvedata).then(() =>
          getProjectDetails()
        )
      }
    });
  };

  const handleCancel = (Status) => {
    Swal.fire({
      title: `Are you sure you want to Cancel This Project?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        let canceldata = {
          projectId: data.projectId,
          status: "Closed",
          approveStatus: Status,
          updatedby: data.updatedby,
          tenantId: data.tenantId,
        }
        ProjectManagementServices.UpdateProjectApproval(canceldata).then(() =>
          getProjectDetails()
        )
      }
    });
  };

  const handleDeleteSiteIncharge = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        ProjectManagementServices.DeleteSiteIncharge(id).then(() =>
          getProjectDetails()
        )
      }
    });
  };

  const handleDeleteAssignClient = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        ProjectManagementServices.DeleteClientAssign(id).then(() =>
          getProjectDetails()
        );
      }
    });
  };

  const handleDeleteProjectManager = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        ProjectManagementServices.DeleteProjectManager(id).then(() =>
          getProjectDetails()
        );
      }
    });
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card card-info">
          <ol className="breadcrumb float-sm-right">
            {/* <Link as="button" className=" text-secondary" to="/projects">
              ❮ Back &nbsp;&nbsp;
            </Link> */}
            <li className="breadcrumb-item text-secondary">
              <Link to="/projectmanagement">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/projects">Projects</Link>
            </li>
            <li className="breadcrumb-item active">Project Details</li>
          </ol>
          <section className="content">
            <div className="container-fluid">
              <div className="card-body">
                {loading === true ? (
                  <div className="text-center">{spin}</div>
                ) : (
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <table className="float-left">
                        <tbody>
                          <tr>
                            <td>Project Name</td>
                            <td> : {data.projectName}</td>
                          </tr>
                          <tr>
                            <td>Project Code</td>
                            <td> : {data.projectCode}</td>
                          </tr>
                          <tr>
                            <td>Status</td>
                            <td> : {data.status}</td>
                          </tr>
                          <tr>
                            <td>Remarks</td>
                            <td> : {data.remark}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>


                    <div className="col-md-12">
                      <Accordion className="overflow-hidden">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor: "#e8ecef" }}
                        >
                          <Typography>Project Manager</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <>
                            <div className="">
                              {data.projectmanager !== undefined &&
                                data.projectmanager !== null &&
                                data.projectmanager.length > 0 ? (
                                <Table
                                  className="float-left table-border"
                                  size="small"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>
                                        project Manager Name
                                      </TableCell>
                                      <TableCell>Contact Number</TableCell>
                                      <TableCell>Email</TableCell>
                                      <TableCell>Action</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data.projectmanager.map((e) => (
                                      <TableRow key={e.id}>
                                        <TableCell>{e.managerName}</TableCell>
                                        <TableCell>
                                          {e.managerContactNo}
                                        </TableCell>
                                        <TableCell>{e.managerEmail}</TableCell>
                                        <TableCell>
                                          {data.approve === "Cancelled" && data.status === "Closed" ? null : (
                                            <div >
                                              {data.approve !== "Approved" && (
                                                <span
                                                  className="cursorpointer"
                                                  onClick={() => handleDeleteProjectManager(e.id)}
                                                >
                                                  <Tooltip title="Delete">
                                                    <img src={deleteIcon} height="20px" width="20px" alt="Delete" />
                                                  </Tooltip>
                                                </span>
                                              )}
                                            </div>
                                          )}
                                        </TableCell>

                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              ) : (
                                ""
                              )}
                            </div>
                            {
                              data.approve === "Cancelled" ? data.status === "Closed" : (
                                <div className="">
                                  {data.approve !== "Approved" && (
                                    <>
                                      <Link
                                        as="button"
                                        className="btn btn-sm hovbuttonColour mr-2 my-2"
                                        to={{ pathname: "/addprojectmanager" }}
                                        state={{
                                          projectId: data.projectId,
                                          projectName: data.projectName,
                                          projectCode: data.projectCode,
                                        }}
                                      >
                                        <i className="fa fa-plus" /> Project Manager
                                      </Link>
                                    </>

                                  )}
                                </div>
                              )}
                          </>

                        </AccordionDetails>
                      </Accordion>
                    </div>

                    <div className="col-md-12 mt-3">
                      <Accordion className="overflow-hidden">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor: "#e8ecef" }}
                        >
                          <Typography>Client</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <>

                            <div className="col-md-12 py-2">
                              {data.clientassign !== undefined &&
                                data.clientassign !== null &&
                                data.clientassign.length > 0 ? (
                                <Table
                                  className="float-left table-border"
                                  size="small"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Client Name</TableCell>
                                      <TableCell>Contact Number</TableCell>
                                      <TableCell>Email</TableCell>
                                      <TableCell>Action</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data.clientassign.map((e) => (
                                      <TableRow key={e.id}>
                                        <TableCell>{e.customerName}</TableCell>
                                        <TableCell>
                                          {e.customerContactNo}
                                        </TableCell>
                                        <TableCell>
                                          {e.customerEmailId}
                                        </TableCell>
                                        <TableCell>
                                          {data.approve === "Cancelled" && data.status === "Closed" ? null : (
                                            <div className="col-md-12">
                                              {data.approve !== "Approved" && (
                                                <span
                                                  className="cursorpointer"
                                                  onClick={() => handleDeleteAssignClient(e.id)}
                                                >
                                                  <Tooltip title="Delete">
                                                    <img src={deleteIcon} height="20px" width="20px" alt="Delete" />
                                                  </Tooltip>
                                                </span>
                                              )}
                                            </div>
                                          )}
                                        </TableCell>

                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              ) : (
                                ""
                              )}
                            </div>
                          </>
                          {
                            data.approve === "Cancelled" ? data.status === "Closed" : (
                              <div className="">
                                {data.approve !== "Approved" && (
                                  <>
                                    <Link
                                      as="button"
                                      className="btn btn-sm hovbuttonColour mr-2 my-2"
                                      to={{ pathname: "/assignclient" }}
                                      state={{
                                        projectId: data.projectId,
                                        projectName: data.projectName,
                                        projectCode: data.projectCode,
                                      }}
                                    >
                                      <i className="fa fa-plus" /> Assign Client
                                    </Link>
                                  </>
                                )}
                              </div>
                            )
                          }

                        </AccordionDetails>
                      </Accordion>
                    </div>

                    <div className="col-md-12 mt-3">
                      <Accordion className="overflow-hidden">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor: "#e8ecef" }}
                        >
                          <Typography>
                            Site
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="row">
                            <div className="col-md-12">

                              <Table className="float-left table-border" size="small" >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Site Incharge Details</TableCell>
                                    <TableCell>Site Address</TableCell>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>

                                  {data.site?.length > 0 && data.site.map((site, i) => (

                                    <TableRow key={i}>
                                      <TableCell>{site.siteName}</TableCell>
                                      <TableCell>{site.siteCode}</TableCell>
                                      <TableCell>{site.status}</TableCell>
                                      <TableCell>
                                        {(
                                          <div className="col-md-12">
                                            <Table className="float-left table-border border" size="small">
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell>Site Incharge Name</TableCell>
                                                  <TableCell>Contact Number</TableCell>
                                                  <TableCell>Email</TableCell>
                                                  <TableCell>Action</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {site.siteIncharges.map((incharge) => (
                                                  <TableRow key={incharge.id}>
                                                    <TableCell>{incharge.inchargeName}</TableCell>
                                                    <TableCell>{incharge.inchargeContactNo}</TableCell>
                                                    <TableCell>{incharge.inchargeEmail}</TableCell>
                                                    <TableCell>
                                                      {data.approve === "Cancelled" && data.status === "Closed" ? null : (
                                                        <div className="col-md-12">
                                                          {data.approve !== "Approved" && (
                                                            <span
                                                              className="cursorpointer"
                                                              onClick={() => handleDeleteSiteIncharge(incharge.id)}
                                                            >
                                                              <Tooltip title="Delete">
                                                                <img src={deleteIcon} height="20px" width="20px" alt="Delete" />
                                                              </Tooltip>
                                                            </span>
                                                          )}
                                                        </div>
                                                      )}
                                                    </TableCell>

                                                  </TableRow>
                                                ))}
                                                <TableRow>
                                                  <TableCell colSpan={4} align="center">
                                                    {
                                                      data.approve === "Cancelled" ? data.status === "Closed" : (
                                                        <div className="col-md-12">
                                                          {data.approve !== "Approved" && (
                                                            <Link
                                                              type="button"
                                                              className=" cursorPointer btn btn-sm hovbuttonColour ml-2 mr-2"
                                                              to={{ pathname: "/addsiteincharge" }}
                                                              state={{
                                                                projectId: data.projectId,
                                                                projectName: data.projectName,
                                                                projectCode: data.projectCode,
                                                                siteIncharges: data.site[i].siteIncharges,
                                                                siteId: site.id,
                                                                siteName: site.siteName,
                                                              }}
                                                            > <i className="fa fa-plus" /> Add site incharge</Link>
                                                          )}
                                                        </div>
                                                      )}

                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </div>
                                        )}
                                      </TableCell>
                                      <TableCell>{site.address}</TableCell>
                                      <TableCell>{`${site.city}, ${site.state}, ${site.country}`}</TableCell>
                                      <TableCell>
                                        {data.approve === "Cancelled" && data.status === "Closed" ? null : (
                                          <div className="col-md-12">
                                            {data.approve !== "Approved" && (
                                              <span
                                                className="cursorpointer"
                                                onClick={() => handleDeleteSite(site.id)}
                                              >
                                                <Tooltip title="Delete">
                                                  <img src={deleteIcon} height="20px" width="20px" alt="Delete" />
                                                </Tooltip>
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </TableCell>

                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>

                            </div>
                            {
                              data.approve === "Cancelled" ? data.status === "Closed" : (
                                <div className="col-md-12">
                                  {data.approve !== "Approved" && (
                                    <>
                                      <FormLabel>
                                        <Link
                                          as="button"
                                          className="btn btn-sm hovbuttonColour mr-2 my-2"
                                          to={{
                                            pathname: "/addsite",
                                          }}
                                          state={{
                                            projectId: data.projectId,
                                            projectName: data.projectName,
                                            projectCode: data.projectCode,
                                          }}
                                        >
                                          <i className="fa fa-plus" /> Add Site
                                        </Link>
                                      </FormLabel>
                                    </>
                                  )}
                                </div>
                              )
                            }

                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>



                    {data.status === "Cancelled" ? data.status === "Approved" :
                      <div className="col-md-12 mt-3">
                        {data.approve === "Approved" ? "" : <>
                          <button
                            type="button"
                            className="btn btn-sm hovbuttonColour mr-2"
                            onClick={() => handleApproveChange("Approved")}
                          >
                            Approve
                          </button>

                          {data.approve === "Pending" ?
                            <button
                              type="button"
                              className="btn btn-sm hovbuttonColour mr-2"
                              onClick={() => handleReviseChange("Revise")}
                            >
                              Revise
                            </button> :

                            <Link
                              type="button"
                              className="btn btn-sm hovbuttonColour mr-2"
                              to="/newproject"
                              state={data}
                            >
                              Edit
                            </Link>

                          }
                        </>
                        }



                        <Link
                          as="button"
                          className="btn btn-sm deletebutton"
                          state={{ message: "Cancelled" }}
                          onClick={() => handleCancel("Cancelled")}
                        >
                          <b className="text-danger"> X </b>Cancel
                        </Link>

                      </div>}
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectDetails;
